



































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { JobListingPlanConfiguration, JobListingPlan, JobListingPlanFeature } from '@/utils/types'

@Component
export default class JobListingPlanConfigurationCrud extends Vue {
  newFeatures: JobListingPlanFeature[] = [];
  addFeature () {
    this.newFeatures.push({
      id: '',
      text: '',
      toolTipText: ''
    })
  }

  @Prop(String) title!: string;
  @Prop(Object) plan?: JobListingPlanConfiguration;
  isLoading = false
  imageForUpload: File | null = null
  data: JobListingPlanConfiguration = this.planPropData

  @Watch('plan')
  onPlanPropChange () {
    this.data = this.planPropData
  }

  get planPropData () {
    return {
      id: this.plan?.id ?? '',
      applicationAmount: this.plan?.applicationAmount ?? 0,
      description: this.plan?.description ?? '',
      features: this.plan?.features ?? [] as JobListingPlanFeature[],
      featuresTitle: this.plan?.featuresTitle ?? '',
      plan: this.plan?.plan ?? JobListingPlan.BASIC,
      price: this.plan?.price ?? 0,
      publishButton: this.plan?.publishButton ?? '',
      publishDuration: this.plan?.publishDuration ?? 0,
      title: this.plan?.title ?? ''
    }
  }

  get isSubmitButtonDisabled () {
    return !this.data.title || !this.data.description || !this.data.featuresTitle
  }

  emitClose () {
    this.$emit('close')
  }

  async emitSubmit () {
    if (this.isSubmitButtonDisabled) {
      return
    }

    const features = [...this.data.features, ...this.newFeatures]
      .filter(feature => feature.text.trim() !== '')
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .map(({ id, ...rest }) => rest)

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { id, ...dataWithoutId } = this.data

    // Convert fields to integer
    const integerFields = ['applicationAmount', 'price', 'publishDuration']
    for (const field of integerFields) {
      dataWithoutId[field] = parseInt(dataWithoutId[field], 10)
    }

    this.$emit('submit', { ...dataWithoutId, features })
  }
}
